import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
    imports: [CommonModule, MatProgressSpinnerModule],
    host: { '[class.fixed-overlay]': 'fixed', '[class.overlay-hidden]': '!showOverlay' }
})
export class LoadingOverlayComponent implements OnInit {
    @Input() showOverlay = false;
    @Input() black = false;
    @Input() fixed = true;
    @Input() transparent = false;
    @Input() zIndex = 1000;

    @Input() diameter: number = 100;
    @Input() strokeWidth: number = 10;

    hideSpinner = true;

    constructor() {}

    ngOnInit() {
        setTimeout(() => {
            this.hideSpinner = false;
        }, 100);
    }
}
